/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["uploads-panel{width:380px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12);background-color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}uploads-panel .header{display:flex;align-items:center;background-color:#1565c0;color:#fff;padding:8px}uploads-panel .header .info{padding-left:10px}uploads-panel .header .actions{margin-left:auto}uploads-panel .header .minimize-icon{width:30px;height:30px}uploads-panel .uploads-list{max-height:350px;overflow:auto}"];
export { styles as styles };
